if (!customElements.get('wollson-shop')) {
    class WollsonShop extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                swiper: 'js-wollson-shop-slides',
                thumbs: 'js-wollson-shop-thumbs',
                list: 'swiper-wrapper',
                item: 'swiper-slide',
                scrollContent: 'js-wollson-shop-scroll-content',
                stickyButtonContent: 'js-wollson-shop-button-content',
                navigation: {
                    prev: 'js-wollson-shop-prev',
                    next: 'js-wollson-shop-next',
                    pagination: 'js-wollson-shop-pagination'
                },
            };

            this.elements = {
                slider: this.querySelector(`.${this.classes.swiper}`),
                thumbs: this.querySelector(`.${this.classes.thumbs}`),
                list: this.querySelector(`.${this.classes.list}`),
                items: this.querySelectorAll(`.${this.classes.item}`),
                scrollContent: this.querySelector(`.${this.classes.scrollContent}`),
                stickyButtonContent: this.querySelector(`.${this.classes.stickyButtonContent}`),
                navigation: {
                    prev: this.querySelector(`.${this.classes.navigation.prev}`),
                    next: this.querySelector(`.${this.classes.navigation.next}`),
                    pagination: this.querySelector(`.${this.classes.navigation.pagination}`)
                }
            };

            this.resizeHandler = this.handleResize.bind(this);
            this.scrollHandler = this.handleScroll.bind(this);
        }

        connectedCallback() {
            if (this.checkIfEmpty()) return;

            this.init();
            window.addEventListener('resize', this.resizeHandler);

            if (this.elements.scrollContent) {
                this.addEventListener('wheel', this.scrollHandler, { passive: false });
            }

            this.initStickyVisibility();
        }

        disconnectedCallback() {
            if (this.swiper) {
                this.swiper.destroy();
            }

            window.removeEventListener('resize', this.resizeHandler);

            if (this.elements.scrollContent) {
                this.removeEventListener('wheel', this.scrollHandler);
            }

            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }
            if (this.hideObserver) {
                this.hideObserver.disconnect();
            }
        }

        checkIfEmpty() {
            const listInner = this.elements.list;
            if (!listInner || !listInner.children.length) {
                this.style.display = 'none';
                return true;
            }
            return false;
        }

        init() {
            if (!this.shouldInitialize()) return;
            this.initializeSwiper();
        }

        shouldInitialize() {
            if (!this.elements.slider || !this.elements.items.length) return false;
            return this.elements.items.length > 1;
        }

        handleResize() {
            if (this.resizeTimeout) clearTimeout(this.resizeTimeout);

            this.resizeTimeout = setTimeout(() => {
                const shouldInit = this.shouldInitialize();

                if (shouldInit && !this.swiper) {
                    this.initializeSwiper();
                } else if (!shouldInit && this.swiper) {
                    this.swiper.destroy(true, true);
                    this.swiper = null;
                }
            }, 300);
        }

        initializeSwiper() {
            const thumbsCount = parseInt(
                this.dataset.heroblockNumberOfShowerThumbs,
                10
            ) || 0;
        
            const totalThumbs =
                this.elements.thumbs?.querySelectorAll('.swiper-slide').length || 0;
        
            const desktopSlidesPerView =
                thumbsCount > 0
                    ? Math.min(thumbsCount, totalThumbs)
                    : 'auto';
        
            this.thumbs = new Swiper(this.elements.thumbs, {
                spaceBetween: 8,
                slidesPerView: 'auto',
                watchSlidesProgress: true,
                breakpoints: {
                    1024: {
                        slidesPerView: desktopSlidesPerView,
                    },
                },
            });
        
            this.swiper = new Swiper(this.elements.slider, {
                slidesPerView: 1,
                spaceBetween: 10,
                watchSlidesProgress: true,
                pagination: {
                    el: this.elements.navigation.pagination,
                    clickable: true,
                },
                navigation: {
                    prevEl: this.elements.navigation.prev,
                    nextEl: this.elements.navigation.next,
                },
                thumbs: {
                    swiper: this.thumbs,
                },
            });
        }

        handleScroll(event) {
            const scrollBox = this.elements.scrollContent;
            if (!scrollBox) return;

            const delta = event.deltaY;

            const prevScrollTop = scrollBox.scrollTop;

            scrollBox.scrollTop += delta;

            const atTop = scrollBox.scrollTop === 0;
            const atBottom =
                scrollBox.scrollTop + scrollBox.clientHeight >= scrollBox.scrollHeight;

            const scrolledInside = scrollBox.scrollTop !== prevScrollTop;

            if (scrolledInside && !atTop && !atBottom) {
                event.preventDefault();
            }

        }

        initStickyVisibility() {
            if (window.innerWidth > 767) return;
        
            const hideOnClasses = this.dataset.hideOnClasses;
            if (!hideOnClasses || !this.elements.stickyButtonContent) return;
        
            const selectors = hideOnClasses
                .split(',')
                .map(item => item.trim())
                .filter(Boolean)
                .map(item => item.startsWith('.') ? item : `.${item}`);
        
            const targets = selectors.flatMap(selector =>
                [...document.querySelectorAll(selector)]
            );
        
            if (!targets.length) return;
        
            this.hideObserver = new IntersectionObserver((entries) => {
                const shouldHide = entries.some(entry => entry.isIntersecting);
        
                this.elements.stickyButtonContent.classList.toggle('is-hidden', shouldHide);
            }, {
                threshold: 0.1
            });
        
            targets.forEach(target => this.hideObserver.observe(target));
        }
    }

    customElements.define('wollson-shop', WollsonShop);
}